var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-edit__views"},[_c('div',{staticClass:"phone-screen__wrapper"},[_c('div',{staticClass:"phone-screen phone-screen-custom"},[_c('div',{staticClass:"phone-screen__inner"},_vm._l((_vm.json),function(widget){return _c(_vm.widgets[widget.name],{key:widget.id,tag:"component",attrs:{"data":widget}})}),1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }